import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import InstallPwaDialogAction from "./InstallPwaDialogAction";

// Note: Although highly modified, the basic idea for this dialog came from this npm package:
// https://github.com/zoltangy/react-pwa-install

export type InstallPwaDialogInitValues = {
    title: ReactNode;
    body: ReactNode;
};

export type InstallPwaDialogResultReason = "install" | "postpone" | "disable";

export type InstallPwaDialogResult = DialogResult<void, InstallPwaDialogResultReason>;

export type InstallPwaDialogProps = DialogProps<InstallPwaDialogInitValues, InstallPwaDialogResult>;

export default function InstallPwaDialog({
    open,
    onClose,
    values
}: InstallPwaDialogProps) {
    return (
        <Dialog
            open={open}
        >
            <DialogTitle id="dialog-title">{values?.title}</DialogTitle>

            <DialogContent>
                <Typography variant="body1">
                    {values?.body}
                </Typography>
            </DialogContent>

            <InstallPwaDialogAction
                onClose={(reason) => onClose({ reason: reason })}
            />
        </Dialog>
    );
}

export type InstallPwaDialogState = DialogState<InstallPwaDialogInitValues, InstallPwaDialogResult>;
export type BindInstallPwaDialogReturn = BindDialogReturn<InstallPwaDialogInitValues, InstallPwaDialogResult>;

export function useInstallPwaDialogState(): InstallPwaDialogState {
    return useDialogState();
}

export function bindInstallPwaDialog(props: InstallPwaDialogState): BindInstallPwaDialogReturn {
    return bindDialog(props);
}
